import { render, staticRenderFns } from "./ManageHotkeys.vue?vue&type=template&id=43ce20df"
import script from "./ManageHotkeys.vue?vue&type=script&lang=js"
export * from "./ManageHotkeys.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports